import Drawer from '@/components/Drawer'
import SvgLib from '@/components/SvgLib'
import MobileDrawerButton from '@/components/MobileDrawerButton'
import OutlineButton from '@/components/OutlineButton'
import LightSources from '@/components/LightSources'

export default {
  data () {
    return {}
  },
  components: { Drawer, SvgLib, MobileDrawerButton, OutlineButton, LightSources }
}



// WEBPACK FOOTER //
// ./src/mixins/ExploreMixin.js